// extracted by mini-css-extract-plugin
export default {"insights":"insights_insights__XV5Gw","contentCard":"insights_contentCard__7E9ke","cardFullHeight":"insights_cardFullHeight__WBsy7","pageHeading":"insights_pageHeading__Auiab"};